import { render } from "./AppNotification.vue?vue&type=template&id=4429191d"
const script = {}

import exportComponent from "/home/circleci/repo/apps/photon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__